/** @module Specification/PartMaterialColor/PartMaterialQuoteRenderer */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/config",
	"csi/def/Action",
	"csi/def/ViewRef",
	"csi/heading/Ref",
	"csi/reflection",
	"csi/xml",
	"csi/xml/Query",
	"Apparel/SupplierItemMixIn"
], function(declare, lang, csi, config, Action, ViewRef, Ref, reflection, xml, Query, SupplierItemMixIn) {

	const COLOR_SPECIFICATION = "ColorSpecification";
	const FOOD_BOMLINE_ITEM = "FoodBOMLineItem";
	const PART_MATERIAL = "PartMaterial";

	return declare([Ref, SupplierItemMixIn], {
		bCopy: true,

		/**
		 * Return PartMaterial node, whether node in context is PartMaterialColor or PartMaterial
		 * @param {Context} ctx
		 * @return {Node}
		 */
		_getPartMaterial: function(ctx) {
			return (ctx.getNodeType() == PART_MATERIAL || ctx.getNodeType() == FOOD_BOMLINE_ITEM) ? ctx.getNode() : ctx.getNodeParent();
		},

		/**
		 * Get Sourcing node
		 * @param {Context} ctx
		 * @return {node}
		 */
		_getSourcingNode: function(ctx) {
			const pm = this._getPartMaterial(ctx);
			const product = ctx.cache.getNode(pm.Actual);
			return product && ctx.cache.getNode(product.ProductSourcing);
		},

		/**
		 * @override
		 * The custom store key should be based off the PartMaterialColor if applicable.  Otherwise use the normal key.
		 */
		getCustomStoreKey: function(ctx, h, bAll) {
			return ctx.getNode().PMCColor;
		},

		/**
		 * @override
		 * Displays quotes that uses the current PMCColor in it's colors list or that has an empty colors list
		 */
		_getStoreAction: function(ctx, h, bAll) {
			var sourceNode = this._getSourcingNode(ctx);

			// Fetch BOMLineSource
			let bomLineSource = ctx.getNode().BOMLineSource;
			if (ctx.getNode().$Type === "PartMaterialColor") {
				bomLineSource = ctx.getNodeParent() && ctx.getNodeParent().BOMLineSource;
			}

			// Store the CommonColor or PMCColor
			if (!sourceNode) {
				return null;
			}

			var color = this._getColor(ctx);

			var q = this._getSupplierItemStoreBaseQueryFilter();
			const {PATH_CURRENT_REVISION} = reflection;
			if (bomLineSource !== csi.EMPTY_URL) {
				q.And().RefAttr("__Parent__", xml.OP_EQUALS, bomLineSource);
			}

			if (color && color.$Type != COLOR_SPECIFICATION && config.getNodeSetting(this._getProductBOM(ctx), "FilterQuotesByColor")) {
				q.Or().Attr2("Colors", xml.OP_EQUALS, {"Dimension": 0, "Path": PATH_CURRENT_REVISION})
					.RefAttr("Colors", xml.OP_EQUALS, color.$URL, PATH_CURRENT_REVISION);
			}

			return lang.mixin(new Action(), {
				m_fixedQuery: q,
				m_viewRef: lang.mixin(new ViewRef(), {
					m_id: "SupplierItems",
					m_url: sourceNode.$URL
				})
			});
		},

		/**
		 * @override
		 * quotes that are assigned to the PMCColor get priority
		 */
		_getPriorityStoreAction: function(ctx, h) {
			var sourceNode = this._getSourcingNode(ctx);
			var color = this._getColor(ctx);

			// Fetch BOMLineSource
			let bomLineSource = ctx.getNode().BOMLineSource;
			if (ctx.getNode().$Type === "PartMaterialColor") {
				bomLineSource = ctx.getNodeParent() && ctx.getNodeParent().BOMLineSource;
			}

			let q = this._getSupplierItemStoreBaseQueryFilter();
			const {PATH_CURRENT_REVISION} = reflection;
			if (bomLineSource !== csi.EMPTY_URL) {
				q.And().RefAttr("__Parent__", xml.OP_EQUALS, bomLineSource);
			}

			if (color) {
				q.Or().Attr2("Colors", xml.OP_EQUALS, {"Dimension": 0, "Path": PATH_CURRENT_REVISION})
					  .RefAttr("Colors", xml.OP_EQUALS, color.$URL, PATH_CURRENT_REVISION);
			}

			if (color && sourceNode) {
				return lang.mixin(new Action(), {
					urlContext: color.$URL,
					m_fixedQuery: q,
					m_viewRef: lang.mixin(new ViewRef(), {
						m_id: "SupplierItems",
						m_url: sourceNode.$URL
					})
				});
			}

			return this.inherited(arguments);
		},

		/**
		 * Get Color node
		 * @param {Context} ctx
		 * @return {node}
		 */
		_getColor: function(ctx) {
			var node = ctx.getNode();
			var color = node.CommonColor || node.PMCColor;
			return ctx.cache.getNode(color);
		},

		/**
		 * Get ProductBOM node
		 * @param {Context} ctx
		 * @return {Node}
		 */
		_getProductBOM: function(ctx) {
			return ctx.cache.getPathNode(ctx.getNode(), this.pathToBOM);
		}
	});
});